<template>
  <div class="swiper-controls">
    <div class="swiper-navigation">
      <button
        @click="handlePrev"
        class="swiper-prev group"
        :disabled="!hasPrev"
      >
        <span class="sr-only">{{ t('prev') }}</span>
        <svg
          class="group-hover:shake-left"
          focusable="false"
          aria-hidden="true"
          width="20"
          height="20"
        >
          <use xlink:href="#arrow-left" />
        </svg>
      </button>
      <button
        @click="handleNext"
        class="swiper-next group"
        :disabled="!hasNext"
      >
        <span class="sr-only">{{ t('next') }}</span>
        <span style="display: block; transform: rotate(180deg)">
          <svg
            class="group-hover:shake-right"
            focusable="false"
            aria-hidden="true"
            width="20"
            height="20"
          >
            <use xlink:href="#arrow-left" />
          </svg>
        </span>
      </button>
    </div>
  </div>
</template>

<i18n>
{
  "en": {
    "prev": "Previous slide",
    "next": "Next slide"
  },
  "de": {
    "prev": "Vorheriger Slide",
    "next": "Nächster Slide"
  }
}
</i18n>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import swiper, { activeIndex } from '../utils/swiper';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  setup() {
    const handleNext = () => {
      if (swiper.value) {
        swiper.value.slideNext();
      }
    };
    const handlePrev = () => {
      if (swiper.value) {
        swiper.value.slidePrev();
      }
    };

    const hasNext = computed(() => {
      if (swiper.value) {
        return activeIndex.value < swiper.value.slides.length - 1;
      }
      return false;
    });

    const hasPrev = computed(() => {
      return activeIndex.value !== 0;
    });

    return { handleNext, handlePrev, hasNext, hasPrev, swiper, ...useI18n() };
  },
});
</script>

<style lang="postcss">
.swiper-prev,
.swiper-next {
  transform: translate3d(0, -50%, 0);
  margin-inline: -1.5rem;
  padding: 1.5rem;
  position: absolute;
  inset-block-start: 50%;
  z-index: 1;

  & svg {
    width: 1.625rem;
    height: 1.375rem;

    @nest .swiper-controls-big & {
      width: 2.5rem;
      height: 2.125rem;
    }
  }
}

.swiper-prev {
  left: 0;
}

.swiper-next {
  right: 0;
}
</style>
